var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isEmptyPortfolio())?_c('div',{staticClass:"empty_wrap"},[_c('div',{staticClass:"img_box"}),_c('div',{staticClass:"text_box"},[_vm._v(_vm._s(_vm.$t('empty_portfolio')))])]):_c('div',{staticClass:"editor ql-editor mb138",domProps:{"innerHTML":_vm._s(_vm.memberData.mb_portfolio)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }